module.exports = __webpack_public_path__ + "img/5-02.91d3b98b.png";